/* eslint-disable import/prefer-default-export */

import irelandApi from '../irelandApi';

export const getNavigationBackground = () => (dispatch) => {
  dispatch({ type: 'GET_NAVIGATION_BACKGROUND_PENDING', payload: [] });

  return irelandApi
    .get('/api/navigation/background')
    .then((response) => {
      const payload = response.data ? response.data : { data: false };
      dispatch({
        type: 'GET_NAVIGATION_BACKGROUND_FULFILLED',
        payLoad: payload,
      });
    })
    .catch((error) => {
      dispatch({ type: 'GET_NAVIGATION_BACKROUND_REJECTED', payLoad: error });
    });
};
